import { render } from "./Experience.vue?vue&type=template&id=5683da83&scoped=true&bindings={}"
import script from "./Experience.vue?vue&type=script&lang=ts"
export * from "./Experience.vue?vue&type=script&lang=ts"

import "./Experience.vue?vue&type=style&index=0&id=5683da83&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-5683da83"

export default script